export enum AdminSupervisorsActiveTab {
    internal = 'internal',
    external = 'external',
}

export enum AdminTabs {
    USER_MANAGEMENT_TAB = 'user-management-tab',
    ORGANIZATION_TAB = 'organization-tab',
    TIMELINES_TAB = 'timelines-tab',
    GRADING_TAB = 'grading-tab',
    DOCUMENTS_TAB = 'documents-tab',
    BILLING_TAB = 'billing-tab',
    EMAILS_TAB = 'emails-tab',
    GENERAL_SETTINGS_TAB = 'general-settings-tab',
}

export enum AdminProjectsTabs {
    ResearchAreas = 'ResearchAreas',
    Projects = 'Projects',
}

export enum TimelineTabs {
    OngoingFuture = 'OngoingFuture',
    Archive = 'Archive',
}

export enum GeneralSettingsTabs {
    Susy = 'Susy',
    Project = 'Project',
}

export enum OrganizationTabs {
    Intakes = 'Intakes',
    Departments = 'Departments',
}

export enum DocumentTabs {
    Files = 'Files',
    Texts = 'Texts',
}

export enum EvaluationTabs {
    Scoring = 'Scoring',
    NonScoring = 'NonScoring',
    GradeSchemas = 'GradeSchemas',
}

export enum HelpTabs {
    Tips = 'tips',
    Documents = 'documents',
}
